import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const SingleTaskList = React.lazy(() => import('../components/SingleTaskList'));
function SingleTaskListView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <SingleTaskList {...props} />
    </Suspense>
  );
}

export default SingleTaskListView;
